// extracted by mini-css-extract-plugin
module.exports = {"iframe":"MonerisProvider_iframe__m_5T6"};